import BaseModule from './BaseModule'

class BasicDataModule extends BaseModule {
  constructor() {
    super()
  }
  // 获取首页基础数据
  getBasicData(){
      return this.get(`/api/report/index`)
  }
}

export default new BasicDataModule()



// WEBPACK FOOTER //
// ./src/api/BasicDataModule.js